<div
  class="accordion_wrapper container"
  [style.padding]="storybook ? '2rem' : '0'"
  id="download-accordion"
>
  <h3 *ngIf="title">{{ title }}</h3>
  <div
    [ngClass]="{ active: isOpen[i], grey: !isSectionBg }"
    class="accordion"
    *ngFor="let accordionItem of accordionItems; let i = index"
    [id]="accordionItem.key"
  >
    <hdi-icon
      *ngIf="hasIcon"
      class="accordion_icon"
      [iconName]="getIcon(accordionItem.icon)"
    ></hdi-icon>
    <span
      class="accordion_title"
      [ngClass]="{ 'accordion_title--no-icon': !hasIcon }"
      (click)="toggleOpenClose(i)"
    >
      {{ accordionItem.name }}
    </span>
    <hdi-button
      class="accordion_btn"
      [label]="headerLabel | capitalize"
      [type]="accordion"
      [isOpen]="isOpen[i]"
      [iconName]="isOpen[i] ? 'pipe' : 'plus'"
      (click)="toggleOpenClose(i)"
      [@rotateAnimation]="animationStates[i]"
    >
    </hdi-button>
    <div
      [ngClass]="{ active: isOpen[i], grey: !isSectionBg }"
      class="accordion_content"
    >
      <div class="accordion_spacer"></div>
      <div
        class="accordion_headline"
        [innerHTML]="accordionItem.Headline"
      ></div>
      <ng-container *ngIf="isOpen[i]">
        <ng-container *ngFor="let utilitiesCards of utilitiesCardsList">
          <hdi-utilities-cards
            *ngIf="utilitiesCards.key === accordionItem.key"
            [utilitiesCards]="utilitiesCards"
            [backgroundColor]="isSectionBg ? 'white' : 'grey'"
          ></hdi-utilities-cards>
        </ng-container>
        <ng-container *ngFor="let item of accordionItem.content">
          <ng-container [ngSwitch]="item.template.uid">
            <!-- Modal Function -->
            <div *ngIf="modalFunctionItems" class="accordion_modal_function">
              <ng-container
                *ngFor="
                  let modalFunctionItem of filterModalFunctionItems(
                    accordionItem.key
                  )
                "
              >
                <hdi-modal-function
                  [ngClass]="{
                    'grid-column-extend': modalFunctionItem.gridColumnExtend,
                  }"
                  [modalFunctionLabel]="modalFunctionItem.label"
                  [type]="modalFunctionItem.type"
                  [showIcon]="modalFunctionItem.showIcon"
                  [modalFunctionHeadline]="modalFunctionItem.headline"
                  [showBadge]="modalFunctionItem.showBadge"
                  [badgeLabel]="modalFunctionItem.badgeLabel"
                  [secondaryIcon]="modalFunctionItem.secondaryIcon"
                  [label]="
                    modalFunctionItem.modalFunctionLabel
                      ? modalFunctionItem.modalFunctionLabel
                      : ('Mehr erfahren' | capitalize)
                  "
                >
                  <h5 class="header-content">
                    {{ modalFunctionItem.modalHeader }}
                  </h5>
                  <p
                    class="modal-content"
                    *ngFor="let content of modalFunctionItem.modalContent"
                    [innerHTML]="content"
                  ></p>
                </hdi-modal-function>
                <div
                  *ngIf="modalFunctionItem.gridColumnExtend"
                  class="grid-column-offset"
                ></div>
              </ng-container>
            </div>
            <!-- Text Block -->
            <hdi-text-block
              *ngSwitchCase="'st_text'"
              [caasData]="item"
            ></hdi-text-block>

            <!-- Static Graphic -->
            <hdi-static-graphic
              *ngSwitchCase="'st_image'"
              [caasData]="item"
            ></hdi-static-graphic>

            <!-- Multimedia List -->
            <ng-container *ngSwitchCase="'st_linklist'">
              <hdi-multimedia-list [caasData]="item"></hdi-multimedia-list>
            </ng-container>
            <!-- Default Case -->
            <!-- <div *ngSwitchDefault>
              Unknown template: {{ item.template?.uid }}
            </div> -->
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
